import React from 'react';
import { useEffect, useRef  } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { exchangeCodeForToken } from '../../redux/slice/authSlice';
import { getLoginUrl } from '../../utils/Constant';
import SplashContent from '../../components/splashScreen/SplashContent';

const Callback = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const hasRun = useRef(false);
  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;
    const init = async () => {
      const params = new URLSearchParams(window.location.search);
      const code = params.get('code');

      if (!code) {
        setTimeout(() => {
          window.location.href = getLoginUrl();
        }, 2000);
        return;
      }

      try {
        await dispatch(exchangeCodeForToken(code)).unwrap();
        setTimeout(() => {
          navigate('/home', { replace: true });
        }, 2000);
      } catch (e) {
        console.error('[Callback] Error:', e);
        setTimeout(() => {
          window.location.href = getLoginUrl();
        }, 2000);
      }
    };

    init();
  }, [dispatch, navigate]);

  return (
    <div className="bg-white absolute left-0 top-0 w-screen h-screen flex flex-col justify-center items-center">
      <SplashContent />
    </div>
  );
};

export default Callback;